// ─── Shared user-avatar color palette ──────────────────────────────────────────
// Extracted verbatim from Users.tsx's local USER_COLORS array (CLAUDE_RULES.md "Color palette
// for user avatars") so other components (Audit Log's UserAvatar) can share the exact same
// palette without duplicating it. Users.tsx itself is left untouched — this is a copy, not a
// refactor of its behavior.
export const USER_COLORS = [
  '#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6',
  '#ec4899', '#06b6d4', '#84cc16', '#f97316', '#14b8a6',
  '#6366f1', '#a855f7', '#e11d48', '#0ea5e9', '#22c55e',
  '#eab308', '#f43f5e', '#7c3aed', '#0891b2', '#65a30d',
];

export const getUserColor = (userId: number): string => USER_COLORS[((userId % USER_COLORS.length) + USER_COLORS.length) % USER_COLORS.length];

// Index 19 (last) — used for "System" avatars (Audit Log Activity timeline, user_id === null).
export const SYSTEM_COLOR = USER_COLORS[19];

export function avatarInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return '?';
}
